import { useExperiment } from '@app/experiments';
import { EXPERIMENTS } from '@app/config';

const useXpressShipping = (hasXpressAsks) => {
  const showXpressShipping = useExperiment(
    EXPERIMENTS.feature_flag_drc_xpress_shipping_web,
  );

  return showXpressShipping && hasXpressAsks;
};

export default useXpressShipping;
